export const pointreport = {
  namespaced: true,
  state: {
    selectedPoint:null,
    loadingAsync: false,
    isOnline: true
  },
  getters: {
  },
  actions: {
    
  },
  mutations: {
    setSelectedPoint(state,point){
      state.selectedPoint = point
    },

    setLoadingAsync(state, loading) {
      state.loadingAsync = loading
    },

    setIsOnline(state, online) {
      state.isOnline = online
    }
  }
}